if(typeof campaign_cf7_controller == 'undefined'){
    var campaign_cf7_controller = {
        params: {},
        fields: [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'utm_term',
            'gclid',
            'fbclid'
        ],
        get_params: function(){
            var url = new URL(window.location);
            var s = url.search;
            if(s.length == 0){
                return;
            }else{
                s = s.split('&');
                s[0] = s[0].replace('?', '');
                var params = {};
                for(var i = 0; i < s.length; i++){
                    var temp = s[i].split('=');
                    temp[0] = temp[0].toLowerCase();
                    params[temp[0]] = decodeURI(temp[1]);
                }
                campaign_cf7_controller.params = params;
            }
        },
        set_values: function(){
            campaign_cf7_controller.get_params();
            for(var i = 0; i < campaign_cf7_controller.fields.length; i++){
                var field = campaign_cf7_controller.fields[i];
                if(typeof campaign_cf7_controller.params[field] != 'undefined'){
                    /*var input = document.getElementById("input_"+field);
                    input.value = campaign_cf7_controller.params[field];*/
                    var input = document.querySelectorAll("input[name='input_"+field+"']");


                    if(input.length > 0){
                        for(var j = 0; j < input.length; j++){
                            input[j].value = campaign_cf7_controller.params[field];
                        }
                    }
                }
            }
            this.form_bind();
        },
        form_bind: function(){

            if(typeof window.syn.cf7_form_config != 'undefined'){
                for(var i in window.syn.cf7_form_config){

                    var form_config = window.syn.cf7_form_config[i];
                    let form_id = form_config.form;
                    switch(form_config.message_type){
                        case 'page':
                            document.addEventListener('wpcf7mailsent', function(event){
                                if(event.detail.contactFormId == form_id){
                                    var url = new URL(form_config.message);
                                    for(var j = 0; j < campaign_cf7_controller.fields.length; j++){
                                        var field = campaign_cf7_controller.fields[j];
                                        if(typeof campaign_cf7_controller.params[field] != 'undefined'){
                                            url.searchParams.set(field, campaign_cf7_controller.params[field]);
                                        }
                                    }
                                    window.location.href = url.href;
                                }
                            });
                            break;
                        case 'message':
                            document.addEventListener('wpcf7mailsent', function(event){
                                window.exit_intent.disable_event = true; //Disable exit firing intent on form submission
                                if(event.detail.contactFormId == form_id){
                                    var form = event.target;
                                    var $parent = jQuery(form).closest('.column.form-column');
                                    var $message = $parent.find('.thank-you-message');
                                    var $form = jQuery(form);
                                    var $pre_form_content = $parent.find('.pre-form-content');
                                    //$form.hide();
                                    $form.css('opacity', '0');
                                    $pre_form_content.css('opacity', '0');
                                    $message.show();
                                    $message.addClass('active');
                                }
                            });
                            break;
                    }
                }

                let field_name = 'your-name';
                let input = document.querySelectorAll("input[name='"+field_name+"']");

                if(input.length > 0){
                    for(var j = 0; j < input.length; j++){
                        input[j].addEventListener('keyup', function(event){
                            let name = event.target.value;
                            name = name.split(' ');
                            let first_name = name[0];
                            let last_name = name.length > 1 ? name.slice(1).join(' ') : '';
                            let first_name_input = document.querySelectorAll("input[name='first_name']");
                            first_name_input.forEach(function(input){
                                input.value = first_name;
                            });

                            let last_name_input = document.querySelectorAll("input[name='last_name']");

                            last_name_input.forEach(function(input){
                                input.value = last_name;
                            });
                        });
                    }
                }

            }else{
            }
        },
        emitTagEvent: function(eventName, eventData){
            if(typeof eventData == 'undefined'){
                data = {};
            }
            if(
                typeof(gtm4wp_datalayer_name) !== 'undefined'
                && campaign_cf7_controller.debug !== true
            ){

                var to_add = {
                    'event': eventName,
                    'eventCategory': 'CF7 Form',
                };

                if(typeof eventData == 'object'){
                    for(var key in eventData){
                        if(eventData.hasOwnProperty(key)){
                            to_add[key] = eventData[key];
                        }
                    }

                    //If we have utms, we add them to the event data
                    for(var i = 0; i < campaign_cf7_controller.fields.length; i++){
                        var field = campaign_cf7_controller.fields[i];
                        if(typeof campaign_cf7_controller.params[field] != 'undefined'){
                            to_add[field] = campaign_cf7_controller.params[field];
                        }
                    }

                }


                window[gtm4wp_datalayer_name].push(to_add);
            }else{
                console.log('EVENT FIRED', 'EVENT:', eventName, 'DATA:', eventData);
            }
        },
    }
    window.campaign_cf7_controller = campaign_cf7_controller;
}
campaign_cf7_controller.set_values();